const Home = () => import('./components/pages/Home.vue');
const Dashboard = () => import('./components/pages/Dashboard.vue');
const ManageUsers = () => import('./components/pages/Manage/Users.vue');
const Auctions = () => import('./components/pages/Manage/Auction.vue');
const Import = () => import('./components/pages/Manage/Import.vue');
const AuctionsDisplay = () => import('./components/pages/Auctions/Display.vue');
const AuctionsSoon = () => import('./components/pages/Auctions/Soon.vue');
const AuctionsActive = () => import('./components/pages/Auctions/Active.vue');
const AuctionsHot = () => import('./components/pages/Auctions/Hot.vue');
const AuctionsClosed = () => import('./components/pages/Auctions/Closed.vue');
const SingleAuction = () => import('./components/pages/SingleAuction.vue');
const ManageBids = () => import('./components/pages/Manage/ManageBids.vue');
const DeleteAuctions = () => import('./components/pages/Manage/DeleteAuctions.vue');
const Winners = () => import('./components/pages/Manage/Winners.vue');

export default [
  {
    name: 'login',
    path: '/login',
    component: Home,
    meta: { redirectIfAuthenticated: true },
  },
  {
    name: 'home',
    path: '/',
    component: Home,
    meta: { redirectIfAuthenticated: true },
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    name: 'manage-users',
    path: '/manage-users',
    component: ManageUsers,
    meta: {
      requiresAuth: true,
      permission: 'manage_users',
    },
  },
  {
    name: 'manage-auctions',
    path: '/manage-auctions',
    props: true,
    component: Auctions,
    meta: {
      requiresAuth: true,
      permission: 'manage_auctions',
    },
  },
  {
    name: 'import-auctions',
    path: '/import-auction',
    props: true,
    component: Import,
    meta: {
      requiresAuth: true,
      permission: 'manage_auctions',
    },
  },
  {
    name: 'auctions',
    path: '/auctions',
    props: true,
    component: AuctionsDisplay,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'auctions-active',
    path: '/auctions/filtered/active',
    props: true,
    component: AuctionsActive,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'auctions-hot',
    path: '/auctions/filtered/hot',
    props: true,
    component: AuctionsHot,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'auctions-soon',
    path: '/auctions/filtered/soon',
    props: true,
    component: AuctionsSoon,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'auctions-closed',
    path: '/auctions/filtered/closed',
    props: true,
    component: AuctionsClosed,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'auction-info',
    path: '/auction/:id?',
    props: true,
    component: SingleAuction,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'manage-bids',
    path: '/manage-bids',
    props: true,
    component: ManageBids,
    meta: {
      requiresAuth: true,
      permission: 'manage_auctions',
    },
  },
  {
    name: 'delete-auctions',
    path: '/delete-auctions',
    props: true,
    component: DeleteAuctions,
    meta: {
      requiresAuth: true,
      permission: 'manage_auctions',
    },
  },
  {
    name: 'auction-winners',
    path: '/manage-winners',
    props: true,
    component: Winners,
    meta: {
      requiresAuth: true,
      permission: 'manage_auctions',
    },
  },
];
